"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ErrorBoundary = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = require("react");
var _utils = require("../../utils");
class ErrorBoundary extends _react.Component {
  constructor(...args) {
    super(...args);
    (0, _defineProperty2.default)(this, "state", {
      error: undefined,
      errorInfo: undefined
    });
  }
  static getDerivedStateFromError(error) {
    return {
      error
    };
  }
  componentDidCatch(error, errorInfo) {
    const {
      logger,
      appName
    } = this.props;
    this.setState({
      errorInfo
    });
    if (logger) {
      logger.error(new Error('ErrorBoundary', {
        cause: error
      }), {
        ...errorInfo
      });
    } else {
      const logError = (0, _utils.getLogger)(appName, _utils.LogLevel.Error);
      logError('ErrorBoundary: ', error, errorInfo);
    }
  }
  render() {
    const {
      error,
      errorInfo
    } = this.state;
    const {
      children,
      fallback
    } = this.props;
    if (error) {
      if (typeof fallback === 'function') {
        return fallback({
          error,
          errorInfo
        }) ?? null;
      }
      return fallback ?? null;
    }
    return children;
  }
}
exports.ErrorBoundary = ErrorBoundary;
//# sourceMappingURL=ErrorBoundary.js.map